import styled from 'styled-components';

var CategoryContainer = styled.div.withConfig({
  displayName: "style__CategoryContainer",
  componentId: "sc-173ldt0-0"
})(["&:not(:last-of-type){margin-bottom:2.4rem;}"]);
var CategoryHeading = styled.h4.withConfig({
  displayName: "style__CategoryHeading",
  componentId: "sc-173ldt0-1"
})(["margin-bottom:1.2rem;font:var(--font-headline-xs);"]);
var ToggleButtonContainer = styled.div.withConfig({
  displayName: "style__ToggleButtonContainer",
  componentId: "sc-173ldt0-2"
})(["display:flex;flex-wrap:wrap;gap:8px;"]);
var ResultIndicator = styled.span.withConfig({
  displayName: "style__ResultIndicator",
  componentId: "sc-173ldt0-3"
})(["margin-left:0.5rem;"]);

export { CategoryContainer, CategoryHeading, ResultIndicator, ToggleButtonContainer };
//# sourceMappingURL=style.js.map
